'use client';

import { css } from '@bts-web/utils-style-engine';
import { FC, ReactNode } from 'react';
import { BitpandaLogoDark } from '../../../common/assets/BitpandaLogoDark';
import { BitpandaLogoLight } from '../../../common/assets/BitpandaLogoLight';
import { PoweredByTextType } from '../../utils';
import { getAppConfig } from '@bts-web/core-app-config';
import { useClientTranslation } from '@bts-web/utils-lokalise';

export const PoweredByText: FC<
  PoweredByTextType & { children?: ReactNode }
> = ({
  fontSize = 'caption.medium_medium',
  value,
  noMargins,
  children,
  inverted,
}) => {
  const { t } = useClientTranslation();

  return (
    <div
      data-testid="powered-by-copy"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        color: inverted
          ? 'neutrals.text_primary_inverted'
          : 'neutrals.text_secondary',
        fontWeight: 'body.medium',
        letterSpacing: 'body.medium',
        lineHeight: 'body.medium',
        fontSize: fontSize,
        whiteSpace: 'wrap',
        ...(noMargins ? {} : { mt: 'small', mb: 'medium' }),
      })}
    >
      {value || t('powered_by_@tenant')}
      {children}
    </div>
  );
};

export const PoweredByTextWithLogo = (
  props: Omit<PoweredByTextType, 'children' | 'fontSize'>,
) => {
  const { isByol, appLogo } = getAppConfig();

  const Logo = appLogo;

  return (
    <PoweredByText
      {...props}
      fontSize="caption.small"
      inverted={props.inverted}
    >
      {isByol ? (
        <Logo />
      ) : props.inverted ? (
        <BitpandaLogoLight />
      ) : (
        <BitpandaLogoDark />
      )}
    </PoweredByText>
  );
};

export const PoweredBy = ({
  showLogo,
  ...props
}: Omit<PoweredByTextType, 'children' | 'fontSize'> & {
  showLogo?: boolean;
}) =>
  showLogo ? (
    <PoweredByTextWithLogo {...props} />
  ) : (
    <PoweredByText {...props} />
  );
